import React, { useEffect, useState } from "react";
import Image from "../../assets/image/png/blog-image.png";
import { useDispatch, useSelector } from "react-redux";
import { getBlogs } from "../../redux/slice/blogSlice";
import HTMLReactParser from "html-react-parser";
import { useNavigate } from "react-router-dom";

const AllBlog = () => {
  const { totalPage, blogs } = useSelector((state) => state.blog);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getBlogs({ page: page, limit: 6 }));
  }, [page]);

  function truncateText(text, maxLength) {
    // Strip HTML tags
    const plainText = text.replace(/<[^>]*>?/gm, '');
    if (plainText.length > maxLength) {
      return plainText.slice(0, maxLength) + "...";
    } else {
      return plainText;
    }
  }

  function formatDate(inputDate) {
    const months = [
      "JANUARY",
      "FEBRUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER",
    ];

    const date = new Date(inputDate);
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const formattedDate = `${month.toUpperCase()} ${day}, ${year}`;
    return formattedDate;
  }

  return (
    <div id="overview" className=" ">
      <div className="container ">
        <h2 className="ff_inter ms-2 pt-5 fw-bold custom-color">Blogs</h2>

        <div className="row pb-5">
          {blogs.map((item, index) => (
            <div className="col-sm-6 col-md-4 p-3 h1-00" key={index}>
              <div
                onClick={() => navigate(`/blog-details/${item._id}`)}
                className="p-3 bg-white rounded-3 h-100 cursor_pointer"
              >
                <div className="w-100 h-100">
                  <img
                    className="rounded-3 w-100 object-fit-cover"
                    height={250}
                    src={item.image}
                    alt=""
                  />
                  <div className="frame-container">
                  <p className="mt-3 custom-color fw-bold ff_helvetica fs_18">
                    {item.title}
                  </p>
                </div>
                  <p className="color_darkgray fs_15 ff_helvetica ">
                    {truncateText(item.description, 200)} {/* Adjust maxLength as needed */}
                  </p>
                  <p className="mt-3 custom-color fw-light ff_helvetica fs_15">
                    {formatDate(item.updatedAt)}
                  </p>
                </div>
              </div>
            </div>
          ))}
          <div className="text-center mt-5 d-flex justify-content-center">
            <button
              className={`allBlogPaginationTab ms-2 ${page === 1 ? "d-none" : ""}`}
              onClick={() => setPage(page - 1)}
            >
              &larr;
            </button>
            {[...Array(totalPage).keys()].map((pages) => (
              <button
                key={pages}
                onClick={() => setPage(pages + 1)}
                className={`allBlogPaginationTab ms-2 ${
                  pages + 1 === page ? "text-white bg-primary" : ""
                }`}
              >
                {pages + 1}
              </button>
            ))}
            <button
              className={`allBlogPaginationTab ms-2 ${page === totalPage ? "custom-color" : "custom-color"}`}
              onClick={() => setPage(page + 1)}
            >
              &rarr;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllBlog;
